import { ReactNode } from "react";
import { X } from "lucide-react";

type PopupProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  className?: string;
  children: ReactNode;
};

export function Popup({ isOpen, onClose, title, className, children }: PopupProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto">
       <div className={`bg-gray-50 dark:bg-zinc-700 p-8 rounded-lg shadow-lg relative ${className}`}>
        {title && <h2 className="text-xl font-bold mb-4">{title}</h2>}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-sky-600 hover:text-sky-700 dark:text-orange-400 dark:hover:text-orange-500"
        >
          <X size={26} />
        </button>
        {typeof children === "function" ? children({ onClose }) : children}
      </div>
    </div>
  );
}
